"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MsgClientImpl = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _m0 = _interopRequireWildcard(require("protobufjs/minimal"));
var _tx = require("./tx");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MsgClientImpl = /*#__PURE__*/function () {
  function MsgClientImpl(rpc) {
    (0, _classCallCheck2["default"])(this, MsgClientImpl);
    (0, _defineProperty2["default"])(this, "rpc", void 0);
    this.rpc = rpc;
    this.placeOrders = this.placeOrders.bind(this);
    this.cancelOrders = this.cancelOrders.bind(this);
    this.registerContract = this.registerContract.bind(this);
    this.contractDepositRent = this.contractDepositRent.bind(this);
    this.unregisterContract = this.unregisterContract.bind(this);
    this.registerPairs = this.registerPairs.bind(this);
    this.updatePriceTickSize = this.updatePriceTickSize.bind(this);
    this.updateQuantityTickSize = this.updateQuantityTickSize.bind(this);
    this.unsuspendContract = this.unsuspendContract.bind(this);
  }
  (0, _createClass2["default"])(MsgClientImpl, [{
    key: "placeOrders",
    value: function placeOrders(request) {
      var data = _tx.MsgPlaceOrders.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.dex.Msg", "PlaceOrders", data);
      return promise.then(function (data) {
        return _tx.MsgPlaceOrdersResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "cancelOrders",
    value: function cancelOrders(request) {
      var data = _tx.MsgCancelOrders.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.dex.Msg", "CancelOrders", data);
      return promise.then(function (data) {
        return _tx.MsgCancelOrdersResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "registerContract",
    value: function registerContract(request) {
      var data = _tx.MsgRegisterContract.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.dex.Msg", "RegisterContract", data);
      return promise.then(function (data) {
        return _tx.MsgRegisterContractResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "contractDepositRent",
    value: function contractDepositRent(request) {
      var data = _tx.MsgContractDepositRent.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.dex.Msg", "ContractDepositRent", data);
      return promise.then(function (data) {
        return _tx.MsgContractDepositRentResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "unregisterContract",
    value: function unregisterContract(request) {
      var data = _tx.MsgUnregisterContract.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.dex.Msg", "UnregisterContract", data);
      return promise.then(function (data) {
        return _tx.MsgUnregisterContractResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "registerPairs",
    value: function registerPairs(request) {
      var data = _tx.MsgRegisterPairs.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.dex.Msg", "RegisterPairs", data);
      return promise.then(function (data) {
        return _tx.MsgRegisterPairsResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "updatePriceTickSize",
    value: function updatePriceTickSize(request) {
      var data = _tx.MsgUpdatePriceTickSize.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.dex.Msg", "UpdatePriceTickSize", data);
      return promise.then(function (data) {
        return _tx.MsgUpdateTickSizeResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "updateQuantityTickSize",
    value: function updateQuantityTickSize(request) {
      var data = _tx.MsgUpdateQuantityTickSize.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.dex.Msg", "UpdateQuantityTickSize", data);
      return promise.then(function (data) {
        return _tx.MsgUpdateTickSizeResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "unsuspendContract",
    value: function unsuspendContract(request) {
      var data = _tx.MsgUnsuspendContract.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.dex.Msg", "UnsuspendContract", data);
      return promise.then(function (data) {
        return _tx.MsgUnsuspendContractResponse.decode(new _m0.Reader(data));
      });
    }
  }]);
  return MsgClientImpl;
}();
exports.MsgClientImpl = MsgClientImpl;